import PropTypes from "prop-types";

import DemographicQuickInfo from "./demographic-quick-info";
import DemographicGraphic from "./demographic-graphic";

import styles from "./styles.module.css";

const DistrictReportDemographicInfo = ({ districtReportDemographicInfos }) => {
  return (
    <div>
      <span className={styles.demographicTitle}>Demografik Bilgiler</span>
      <DemographicQuickInfo districtReportDemographicInfos={districtReportDemographicInfos} />
      {districtReportDemographicInfos?.graphics && (
        <DemographicGraphic districtReportDemographicInfos={districtReportDemographicInfos} />
      )}
    </div>
  );
};

DistrictReportDemographicInfo.propTypes = {
  districtReportDemographicInfos: PropTypes.object,
};

export default DistrictReportDemographicInfo;
